import { Component, ChangeDetectionStrategy, Input, ElementRef, ViewChild, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-rating-bar',
  templateUrl: './rating-bar.component.html',
  styleUrls: ['./rating-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RatingBarComponent {
  @Input()
  public readonly rating: number = null;
  @Input()
  public readonly type: string = 'agent';
  @Input()
  public readonly form: 'small' | 'normal' = 'normal';

  @Output() changeRating = new EventEmitter<number>();

  @ViewChild('bar') starBar: ElementRef<HTMLElement>;

  public onClick(e: MouseEvent): void {
    if (typeof this.starBar.nativeElement === 'object' && this.starBar.nativeElement !== null && 'getBoundingClientRect' in this.starBar.nativeElement) {
      const width = this.starBar.nativeElement.clientWidth;
      const startX = this.starBar.nativeElement.getBoundingClientRect().x;
      const rate = ((e.x - startX) / width) * 5;
      this.changeRating.emit(Math.ceil(rate));
    }
  }
}
